<template>
  <div>
    <div class="container">
      <div class="form">
        <div class="title">请确认您购买的服务信息</div>
        <img
          class="t-icon"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022-11-9-cna-order-icon"
          alt=""
        />
        <div class="f-list">
          <div class="f-item">
            <div class="f-top">
              <img
                class="f-icon"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022-11-9-cna-active-icon-1"
                alt=""
              /><span>您{{ fromName }}的订单号</span>
            </div>
            <input
              class="f-input"
              placeholder="请输入订单号"
              type="text"
              v-model="orderId"
            />
          </div>
          <div class="f-item">
            <div class="f-top">
              <img
                class="f-icon"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022-11-9-cna-active-icon-2"
                alt=""
              /><span>服务名称</span>
            </div>
            <input
              class="f-input f-input-disabled"
              disabled
              placeholder="请输入服务名称"
              type="text"
              v-model="name"
            />
          </div>
          <div class="f-item">
            <div class="f-top">
              <img
                class="f-icon"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022-11-9-cna-active-icon-3"
                alt=""
              /><span>课程绑定手机号码</span>
            </div>
            <input
              class="f-input f-input-disabled"
              disabled
              placeholder="请输入手机号码"
              type="number"
              v-model="phone"
            />
          </div>
        </div>

        <div
          class="btn"
          :class="{ 'btn-disabled': disabledSubmit }"
          @click="bindActive"
          >绑定激活</div
        >
      </div>
    </div>
    <van-overlay :show="showToast" @click="bindClose">
      <div class="wrapper" @click.stop>
        <div class="content success" v-if="success">
          <img
            class="icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022-11-9-cna-success-icon"
            alt=""
          />
          <div>激活成功</div>
        </div>
        <div class="content error" v-else>
          <img
            class="icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022-11-9-cna-error-icon"
            alt=""
          />
          <div style="padding: 0px 20px; text-align: center">{{ errMsg }}</div>
        </div>
        <div class="close iconfont icon-cha" @click="bindClose"></div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  data() {
    return {
      phone: '',
      name: '',
      orderId: '',
      errMsg: '',
      disabledSubmit: true,
      showToast: false,
      success: false,
      fromName: '',
      fromData: {
        1: {
          id: 1,
          name: '快手',
          reg: /^\d{16}$/
        },
        2: {
          id: 2,
          name: '抖音',
          reg: /^[1-9]\d{18}$/
        },
        4: {
          id: 4,
          name: '小鹅通',
          reg: /^o_\d{10}_[0-9a-zA-Z]{13}_\d{8}$/
        },
        7: {
          id: 7,
          name: 'APP',
          reg: /^\d{15}$/
        },
        5: {
          id: 5,
          name: '小红书',
          reg: /^P\d{18}$/
        },
        12: {
          id: 12,
          name: '支付宝',
          reg: /^\d{28}$/
        }
      }
    }
  },
  watch: {
    orderId(val) {
      this.disabledSubmit = !val
    }
  },
  created() {
    let fromName = this.$route.query.from_name
    this.fromName = fromName ? '"' + fromName + '"' : ''
    this.getParams()
  },
  mounted() {},
  methods: {
    bindClose() {
      this.showToast = false
      if (this.success) {
        setTimeout(() => {
          this.$router.push('recipe-cna-download')
        }, 500)
      }
    },
    getParams() {
      this.phone = this.$route.query.phone
      let name = ''
      if (this.$route.query.ver <= 2) {
        name = this.$route.query.type + '日营养评估方案'
      } else {
        let verObj = {
          3: '4.0',
          4: '4.1'
        }
        name = 'CNA全方位营养评估' + (verObj[this.$route.query.ver] || '')
      }
      this.name = name
    },
    /* 检查订单 */
    checkOrder(str = '') {
      let res
      let reg =
        (this.fromData[this.$route.query.s_from] &&
          this.fromData[this.$route.query.s_from].reg) ||
        null
      if (reg) {
        res = str.match(reg)
      }
      return res
    },
    bindActive() {
      if (this.disabledSubmit || this.submiting) {
        return
      }
      if (!this.name) {
        this.$toast('服务名称不能为空')
        return
      }
      if (!this.phone) {
        this.$toast('电话号码不能为空')
        return
      }
      if (!this.checkOrder(this.orderId)) {
        this.errMsg = '激活失败，请联系客服'
        this.showToast = true
        this.success = false
        return
      }
      this.submiting = true
      let params = {
        order: this.orderId,
        phone: this.phone,
        plan_type: this.$route.query.plan_type,
        s_from: this.$route.query.s_from,
        version: this.$route.query.version
      }
      this.$http
        .postBaseApp('member/CnaAutoIssued/activationCna', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.showToast = true
            this.success = true
          } else {
            this.errMsg = res.msg
            this.showToast = true
            this.success = false
          }
        })
        .catch(() => {
          this.$toast('网络异常')
        })
        .finally(() => {
          this.submiting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  overflow: hidden;
  width: 100%;
  min-height: 100vh;
  position: relative;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022-11-9-cna-bg');
  background-position: center top;
  background-repeat: no-repeat;
  background-size: 100%;

  .form {
    width: 335px;
    box-sizing: border-box;
    margin: 313px auto 100px;
    background: #ffffff;
    box-shadow: 0px 6px 12px 0px rgba(55, 54, 84, 0.05);
    border-radius: 12px;
    padding: 24px 20px 36px;

    .title {
      text-align: center;
      font-size: 22px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 600;
      color: #373d52;
      line-height: 25px;
      margin-bottom: 4px;
    }

    .t-icon {
      width: 19px;
      height: 16px;
      margin: 0 auto;
      margin-bottom: 19px;
    }

    .f-list {
      margin-bottom: 63px;
    }

    .f-item {
      margin-bottom: 25px;
    }

    .f-item:last-child {
      margin-bottom: 0;
    }

    .f-top {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      margin-bottom: 5px;

      .f-icon {
        width: 22px;
        height: 22px;
        margin-right: 4px;
        object-fit: contain;
      }
    }

    .f-input {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      padding: 0px 10px;
      box-sizing: border-box;
      width: 100%;
      border: none;
      outline: none;
      height: 40px;
      background: linear-gradient(
        133deg,
        rgba(174, 157, 255, 0.1) 0%,
        rgba(98, 54, 255, 0.1) 100%
      );
      border-radius: 10px;
    }

    .f-input-disabled {
      color: rgba(0, 0, 0, 0.5);
      background: linear-gradient(360deg, #f9f9f9 0%, #f5f5f7 100%);
    }

    .f-input::placeholder {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.3);
      line-height: 20px;
    }

    .btn {
      width: 287px;
      margin: 0 auto;
      height: 50px;
      line-height: 50px;
      background: #6759ff;
      border-radius: 25px;
      font-size: 20px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 600;
      text-align: center;
      color: #ffffff;
    }

    .btn-disabled {
      background: #d4d5dd;
    }
  }
}

.wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 241px;
  height: 241px;
  background: #ffffff;
  border-radius: 12px;

  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;

    .icon {
      width: 101px;
      height: 76px;
      object-fit: contain;
      margin-bottom: 34px;
    }
  }

  .close {
    position: absolute;
    bottom: -50px;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 25px;
    height: 25px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    box-sizing: border-box;
    border: 1px solid #fff;
  }
}
</style>
